import { useEffect, useState } from 'react'
import { RefreshCw, X } from 'lucide-react'

/**
 * SwUpdateBanner — Phase CL-B M-2
 *
 * Service Worker 가 업데이트되어 새 캐시가 활성화될 때 (`app:reload-required` 이벤트 수신),
 * 사용자에게 "새 버전이 있습니다. 새로고침" 배너 표시.
 *
 * - 강제 reload 없음 — 사용자가 [새로고침] 버튼을 직접 눌러야 동작
 * - [닫기] 로 무시 가능 (다음 SW 업데이트 시 다시 노출)
 * - PC + Mobile 공용 (상단 고정, z-index 최상위)
 */
export default function SwUpdateBanner() {
  const [show, setShow] = useState(false)

  useEffect(() => {
    const handler = () => setShow(true)
    window.addEventListener('app:reload-required', handler)
    return () => window.removeEventListener('app:reload-required', handler)
  }, [])

  if (!show) return null

  return (
    <div
      role="status"
      aria-live="polite"
      className="fixed top-0 left-0 right-0 z-[100000] bg-gradient-to-r from-blue-600 to-indigo-600 text-white shadow-lg"
      style={{ paddingTop: 'max(0px, env(safe-area-inset-top))' }}
    >
      <div className="max-w-screen-xl mx-auto px-4 py-3 flex items-center justify-between gap-3">
        <div className="flex items-center gap-2 min-w-0">
          <RefreshCw className="w-4 h-4 flex-shrink-0" aria-hidden="true" />
          <span className="text-sm font-medium truncate">
            새 버전이 있습니다. 새로고침 후 이용해 주세요.
          </span>
        </div>
        <div className="flex items-center gap-2 flex-shrink-0">
          <button
            type="button"
            onClick={() => window.location.reload()}
            className="min-h-[44px] min-w-[44px] inline-flex items-center justify-center px-3 py-1.5 rounded-lg bg-white text-blue-700 text-sm font-semibold hover:bg-blue-50 transition"
          >
            새로고침
          </button>
          <button
            type="button"
            onClick={() => setShow(false)}
            aria-label="닫기"
            className="min-h-[44px] min-w-[44px] inline-flex items-center justify-center rounded-lg text-white/80 hover:text-white hover:bg-white/10 transition"
          >
            <X className="w-5 h-5" />
          </button>
        </div>
      </div>
    </div>
  )
}
